export const errorMsgs = {
  STAKEHOLDER_ERROR: "Check list is not available for this stakeholder.",
  STAKEHOLDERS_DOCUMENT_ERROR: "Stakeholder documents are not found.",
  COMPANY_DOCUMENT_ERROR: "Company documents are not found."
};

export const titles = {
  COMPANY_TITLE: "Company",
  STAKEHOLDER_TITLE: "Stakeholder",
  DOCUMENT_TITLE: "Document Title",
  UPLOAD_STATUS_TITLE: "Upload Status",
  ACTIONS_TITLE: "Actions",
  PRINT_DOWNLOAD_TITLE: "Print / Download"
};

export const STATUS_NOT_ELIGIBLE = ["Quarantined"];
export const UPLOAD = "Upload ";
